import Components from "../../../../components"
import CourseAsset from "../CourseAsset"
import { CourseAssetsView } from "./CourseAssets"
import { OnlineCourseStrucureView } from "./CourseStructure"

// color: #211D71;
// background: #F7F6FF;
const CoursePart = ({ label, name, value, data, onAddNew, onChange, selectedId }) => {
    return <div style={{
        display: 'flex',
        fontSize: '14px',
        alignItems: 'center',
        marginBottom: 20
    }}>
        <div
            style={{
                display: 'inline-block',
                color: '#211D71',
                padding: '10px 10px',
                paddingLeft: '0',
                margin: '0 5px',
                marginLeft: '0'
            }}
        >
            Books
        </div>
        <div
            style={{
                flex: 1,
                border: '1px solid #211D71'
            }}
        >
            {
                data.map(v => {
                    const isSelected = selectedId === v._id;
                    return <div 
                        style={{
                            cursor: 'pointer',
                            display: 'inline-block',
                            backgroundColor: isSelected? '#211D71' : '#F7F6FF',
                            color: !isSelected? '#211D71' : '#F7F6FF',
                            padding: '10px 10px',
                            margin: '0 5px'
                        }}
                        onClick={(e) => onChange(e, 'month', v._id)}
                    >
                        {v.title}
                    </div>
                })
            }
        </div>
        <div
            style={{
                display: 'inline-block',
                color: '#211D71',
                padding: '10px 10px',
                margin: '0 5px'
            }}
        >
            <Components.buttons.FlatButton onClick={onAddNew}>Add New Book</Components.buttons.FlatButton>
        </div>

    </div>
}



const OnlineCourseDetailsView = ({
    course, months, weeks, days, assets,
    isAssetsLoading,
    selectedMonth, selectedWeek, selectedDay, selectedAsset,
    onPublishCourse,
    onChageSelectedAssetPointer,
    onChangeMonth, onChangeWeek, onChangeDay, onChangeAsset,
    onAddMonth, onAddWeek, onAddDay, onAddAsset,
    onDeleteAsset,
    ...props
}) => {

    const selectedPart = selectedMonth;
    const selectedModule = selectedWeek;
    const selectedTopic = selectedDay;

    return <div className="online-course">
        <h2>Course Details</h2>
        <div>Batch Title: {course.title}</div>
        <div>Symbol: {course.symbol}</div>
        <div>Description: {course.description}</div>
        <div>No of Months: {course.nMonths}</div>
        <Components.buttons.FlatButton onClick={onPublishCourse}>Publish</Components.buttons.FlatButton>
        <h3>Course Structure</h3>
        <CoursePart
            key={selectedMonth}
            label="Months"
            name="selectedMonth"
            data={months}
            value={selectedMonth}
            onChange={onChageSelectedAssetPointer}
            onAddNew={onAddMonth}
            selectedId={selectedMonth}
        />
        <div className="u-flex--row">
            <div style={{ flex: 1 }}>

                <OnlineCourseStrucureView
                    {...{
                        course, months, weeks, days, assets,
                        selectedMonth, selectedWeek, selectedDay, selectedAsset,
                        onPublishCourse,
                        onChageSelectedAssetPointer,
                        onChangeMonth, onChangeWeek, onChangeDay, onChangeAsset,
                        onAddMonth, onAddWeek, onAddDay, onAddAsset,
                        onDeleteAsset,
                        ...props
                    }}
                />
            </div>

            <div style={{ flex: 3 }}>
                {
                    selectedDay && !isAssetsLoading && 
                    [selectedDay].map(v => {
                        const topic = days.filter(v => v._id === selectedDay)[0];
                        return <CourseAssetsView
                            key={`${topic._id}|${topic.assets.join('|')}`}
                            onDeleteAsset={onDeleteAsset}
                            onAddAsset={onAddAsset}
                            topic={topic}
                            assets={assets}
                        />
                    })
                }
            </div>

        </div>
    </div>
}

export default OnlineCourseDetailsView